// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1ofsv","savePackageButton":"ClientWallet_savePackageButton__2HqDI"};